import { useState, useEffect, useCallback } from "react";

import { api_without_cancellation } from "../../../../api/api";

const useCaseStagesStatuses = () => {
  const [allCaseStages, setAllCaseStages] = useState([]);
  const [allCaseStatuses, setAllCaseStatuses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchCaseStages_Statuses = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await api_without_cancellation.get(
        "/api/navigator/navigator_stages_statuses/"
      );

      setAllCaseStages(response.data.all_stages);
      setAllCaseStatuses(response.data.all_statuses);
    } catch (err) {
      setError(err.message || "Failed to fetch case stages and statuses");
      console.error("Error fetching case stages and statuses:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCaseStages_Statuses();
  }, [fetchCaseStages_Statuses]);

  return {
    allCaseStages,
    allCaseStatuses,
    loading,
    error,
    refetch: fetchCaseStages_Statuses,
  };
};

export default useCaseStagesStatuses;
